<template>
  <div class="w-full max-w-6xl mx-auto">
    <div class="border-b-2">
      <div class="flex justify-between items-center">
        <div class="py-4 flex items-center">
          <Link href="/">
            <img
              class="h-12 w-auto"
              src="@/../assets/images/logo.png"
              alt="Open CDL Jobs"
            />
          </Link>

          <nav class="ml-8 space-x-8">
            <Link
              href="/jobs"
              class="text-sm font-medium text-gray-500 hover:text-gray-900 transition"
              >Jobs</Link
            >
            <Link
              href="/drivers"
              class="text-sm font-medium text-gray-500 hover:text-gray-900 transition"
              >Drivers</Link
            >
            <Link
              href="/drivers"
              class="text-sm font-medium text-gray-500 hover:text-gray-900 transition"
              >FAQs</Link
            >
            <Link
              href="/drivers"
              class="text-sm font-medium text-gray-500 hover:text-gray-900 transition"
              >Contact</Link
            >
            <Link
              href="/drivers"
              class="text-sm font-medium text-gray-500 hover:text-gray-900 transition"
              >Support</Link
            >
          </nav>
        </div>

        <div>
          <ProfileDropdown />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";

import ProfileDropdown from "@/components/ProfileDropdown";

export default {
  components: {
    Link,
    ProfileDropdown,
  },
};
</script>
